import type { SortKey } from '../hooks/useListControls';
import styles from './ListControls.module.css';

type ListControlsProps = {
  search: string;
  onSearchChange: (value: string) => void;
  sort: SortKey;
  onSortChange: (value: SortKey) => void;
  searchPlaceholder?: string;
};

export function ListControls({
  search,
  onSearchChange,
  sort,
  onSortChange,
  searchPlaceholder = 'Search…',
}: ListControlsProps) {
  return (
    <div className={styles.controls}>
      <input
        type="search"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        className={styles.searchInput}
        aria-label="Search"
      />
      <label className={styles.sortLabel} htmlFor="list-sort">
        Sort
      </label>
      <select
        id="list-sort"
        value={sort}
        onChange={(e) => onSortChange(e.target.value as SortKey)}
        className={styles.sortSelect}
        aria-label="Sort"
      >
        <option value="updated-desc">Recently updated</option>
        <option value="updated-asc">Least recently updated</option>
        <option value="created-desc">Newest</option>
        <option value="created-asc">Oldest</option>
        <option value="name-asc">Name A–Z</option>
        <option value="name-desc">Name Z–A</option>
      </select>
    </div>
  );
}
